//load polyfills before vue components for ie 11
import 'core-js/es/symbol';
import 'core-js/es/object';
import 'core-js/es/function';
import 'core-js/es/parse-int';
import 'core-js/es/parse-float';
import 'core-js/es/number';
import 'core-js/es/math';
import 'core-js/es/string';
import 'core-js/es/date';
import 'core-js/es/array';
import 'core-js/es/regexp';
import 'core-js/es/map';
import 'core-js/es/set';
import './polyfills/NodeListPolyfill';
import 'promise-polyfill/src/polyfill';

// Common filters
import FilterPack from './filters/FilterPack';

// Common components
import ContentItem from './components/ContentItem.vue';
import ErrorPanel from './components/ErrorPanel.vue';
import Loading from './components/Loading.vue';
import PasswordTextBox from './components/PasswordTextBox.vue';

// Common mixins
import UniqueIdMixin from './mixins/UniqueIdMixin';

// Common directives
import { vMaska } from 'maska';

export default {
    install(Vue) {
        // Register common filters
        Vue.use(FilterPack);

        // Register common components
        Vue.component('content-item', ContentItem);
        Vue.component('error-panel', ErrorPanel);
        Vue.component('loading', Loading);
        Vue.component('password-textbox', PasswordTextBox);

        // Register common mixins
        Vue.use(UniqueIdMixin);

        // Register common directives
        Vue.directive('maska', vMaska);

    }
};
